import { Alert, AlertDescription } from "@/components/ui/alert";
import { Info } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export const EmptyMilestones = () => {
  return (
    <Card>
      <CardContent className="p-6">
        <Alert>
          <Info className="h-4 w-4" />
          <AlertDescription>
            Keep going! Complete stages in the Testing Modules to earn milestones.
            <ul className="list-disc pl-6 mt-2 space-y-1">
              <li>Category milestone: Complete all tests in a subject area for a specific age</li>
              <li>Stage milestone: Complete all tests across a subject for a specific age</li>
            </ul>
          </AlertDescription>
        </Alert>
      </CardContent>
    </Card>
  );
};